import {
  apiCountries,
  apiGetListCustomer,
  apiGetListNetwork,
  apiGetListPackage,
  apiGetListSupplier,
  apiGetListBank,
  apiWarehouseApproval,
  apiGetListCountry,
  apiGetListCustomerB2B,
} from "./urls"
import http from "../index"

const getListAllCustomer = params => http.get(apiGetListCustomer, { params })
const getListAllPackage = params => http.get(apiGetListPackage, { params })
const getListAllNetwork = params => http.get(apiGetListNetwork, { params })
const getListAllSupplier = () => http.get(apiGetListSupplier)
const getAllCountries = (params) => http.get(apiCountries, {params})
const getListAllBank = () => http.get(apiGetListBank)
const getWarehouseApproval = (params) => http.get(apiWarehouseApproval, {params})
const getListAllCountryToB2b = (params) => http.get(apiGetListCountry, {params})
const getListCustomerB2B =  (params) => http.get(apiGetListCustomerB2B, {params})
const DropdownService = {
  getListAllCustomer,
  getListAllPackage,
  getListAllNetwork,
  getListAllSupplier,
  getAllCountries,
  getListAllBank,
  getWarehouseApproval,
  getListAllCountryToB2b,
  getListCustomerB2B
}
export default DropdownService
